var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThreeBookStack = function SvgThreeBookStack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223,
    height: 95,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    stroke: "#FAFAFA",
    d: "M210.58 81.954h-59.115v12.04h59.115zM212.791 68.472h-58.894v12.04h58.894zM217.652 54.99h-58.894v12.04h58.894zM221.631 41.509h-58.894v12.04h58.894zM210.58 28.027h-59.115v12.04h59.115zM206.16 14.545h-58.894v12.04h58.894zM64.686 81.954H5.57v12.04h59.116zM66.897 68.472H8.003v12.04h58.894zM71.758 54.99H12.864v12.04h58.894zM75.736 41.509H16.842v12.04h58.894zM64.686 28.027H5.57v12.04h59.116zM60.266 14.545H1.372v12.04h58.894z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    stroke: "#FAFAFA",
    d: "M139.756 81.944H80.817v12.05h58.939zM137.543 68.453h-59.16v12.05h59.16zM139.756 54.96H80.817v12.05h58.939zM145.727 41.469H86.788v12.05h58.939zM142.631 27.977H83.692v12.05h58.939zM136.217 14.486H77.278v12.05h58.939zM139.756.994H80.817v12.05h58.939z"
  })));
};
export { SvgThreeBookStack as ReactComponent };
export default __webpack_public_path__ + "images/three-book-stack.svg";